


















































import Vue from 'vue'
import PosterTable from '@/components/PosterTable.vue'
import BackButton from '@/components/BackButton.vue'
import Worker from '@/components/Worker.vue'

export interface Criterios {
  titulo: string
  criterios: string[]
}

export interface AdminComponentData {
  search: string | null
  criterios: Criterios
}

export default Vue.extend({
  components: {
    PosterTable,
    BackButton,
    Worker,
  },

  data: (): AdminComponentData => ({
    search: null,
    criterios: {
      titulo:
        'Para la evaluación de las propuestas tenga en cuenta los siguientes ítems:',
      criterios: [
        'El título sintetiza el tema del resumen.',
        'Las palabras clave permiten determinar el campo o subcampo del estudio.',
        'Se describen brevemente el(los) objetivo(s) de la investigación.',
        'Se presenta de manera sucinta el diseño metodológico.',
        'Se sintetizan los principales resultados.',
        'Se describe de forma clara y precisa las principales conclusiones.',
        'Existe coherencia entre el título, palabras clave y resumen.',
      ],
    },
  }),
})
